import { __ } from '@wordpress/i18n';
import { RichText } from '@wordpress/block-editor';
import { Tooltip } from '@wordpress/components';

const AlertBox = ({ attributes, isBackend = false, wp }) => {
	const { message, icon, isDismiss } = attributes;

	const AlertDismiss = () => isBackend ? <Tooltip text='Hide will only work in frontend' position='top center'>
		<i className='alertClose fa fa-times-circle'></i>
	</Tooltip> : <i className='alertClose fa fa-times-circle'></i>

	return <div className='abbAlertBox'>
		<div className='alert'>
			{icon?.class && <i className={`alertIcon ${icon?.class}`}></i>}

			{isBackend ? <RichText className='alertMessage' tagName='span' value={message} onChange={val => wp.setAttributes({ message: val })} placeholder={__('Alert Message', 'alert-box-block')} inlineToolbar /> : message && <RichText.Content className='alertMessage' tagName='span' value={message} />}

			{isDismiss && <AlertDismiss />}
		</div>
	</div>
}
export default AlertBox;